import React from "react";
import { Landing } from "./pages/Landing";
import { useMetaPixel } from "./hooks/useMetaPixel";
export function App() {
  useMetaPixel();
  return <Landing data-id="element-0" data-mp="35c28kv02tw3o" />;
}